import React from "react";
import calculateSize from "calculate-size";
import { pure, compose, withProps } from "recompose";
import "./Safeword.css";

const style = {
  font: "Open Sans Condensed",
  fontSize: "120px"
};

const compensateDimensions = ({ width, height }) => ({
  width,
  height: height * 1.3
});

const computeSafewordScale = (safeword, dimensions) => {
  const compensatedDimensions = compensateDimensions(dimensions);
  // calculateSize for some reason tries to modify the style object
  // so we need to create a copy
  const ratio = calculateSize(safeword, { ...style });
  return ["width", "height"].map(d => compensatedDimensions[d] / ratio[d]);
};

const normalizeSafeword = safeWord =>
  `${safeWord || ""}`
    .split(" ")
    .join("")
    .toUpperCase();

const mapProps = withProps(({ safeword: rawSafeword, dimensions }) => {
  const safeword = normalizeSafeword(rawSafeword);
  const safewordScale = computeSafewordScale(safeword, dimensions);
  return {
    safeword,
    styles: {
      ...style,
      transform: `scale(${safewordScale.join(",")})`
    }
  };
});

const className = (...args) => args.filter(Boolean).join(" ");

const View = ({ isSafewordAgreed, safeword, safewordTyped, styles }) => (
  <div className="safeword">
    <div className="bottom" style={styles}>
      {safeword}
    </div>
    <div
      className={className(
        "top",
        (!isSafewordAgreed || safewordTyped) && "active"
      )}
      style={styles}
    >
      {safewordTyped || safeword}
    </div>
  </div>
);

export default compose(pure, mapProps)(View);



// WEBPACK FOOTER //
// ./src/components/Safeword/Safeword.js